import { useMutation } from 'react-query';
import { Http } from '../../services/Http';
import { Deal } from '../../types';
import { MUTATION_KEYS } from '../constants';
import { useInvalidateDeals } from './useDeals';
import { useInvalidateUsers } from './useUsers';

async function archiveDeal(id: number): Promise<number> {
  const { data } = await Http.axios.delete<number>(`/deal/${id}`);
  return data;
}

async function unarchiveDeal(id: number): Promise<Deal> {
  const { data } = await Http.axios.patch<{ isActive: boolean }, Deal>(`/deal/${id}`, {
    isActive: true,
  });
  return data;
}

export const useArchiveDeal = () => {
  const invalidateDeals = useInvalidateDeals();
  const invalidateUsers = useInvalidateUsers();

  return useMutation(archiveDeal, {
    mutationKey: MUTATION_KEYS.DELETE_DEAL_KEY,
    onSuccess: () => {
      invalidateDeals();
      invalidateUsers();
    },
  });
};

export const useUnarchiveDeal = () => {
  const invalidateDeals = useInvalidateDeals();
  const invalidateUsers = useInvalidateUsers();

  return useMutation(unarchiveDeal, {
    mutationKey: MUTATION_KEYS.UNARCHIVE_DEAL_KEY,
    onSuccess: () => {
      invalidateDeals();
      invalidateUsers();
    },
  });
};
